"use strict";

var _interopRequireDefault = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _objectSpread2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _productConfig = require("@/api/product-config");
var ConfigModal = /*#__PURE__*/function (_Vue) {
  function ConfigModal() {
    var _this;
    (0, _classCallCheck2.default)(this, ConfigModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ConfigModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "loadingSubmit", false);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {});
    (0, _defineProperty2.default)(_this, "rules", {
      value: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      }
    });
    (0, _defineProperty2.default)(_this, "loading", false);
    return _this;
  }
  (0, _inherits2.default)(ConfigModal, _Vue);
  return (0, _createClass2.default)(ConfigModal, [{
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var valid;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$refs.form.validate();
            case 2:
              valid = _context.sent;
              if (!valid) {
                _context.next = 14;
                break;
              }
              _context.prev = 4;
              this.loadingSubmit = true;
              _context.next = 8;
              return _productConfig.productConfigApi.updateAll(this.form);
            case 8:
              this.$notify({
                title: "Thông báo",
                message: "Thành công!",
                type: "success"
              });
              this.$emit("submit:success");
              this.visible = false;
            case 11:
              _context.prev = 11;
              this.loadingSubmit = false;
              return _context.finish(11);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4,, 11, 14]]);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "handleUpdate",
    value: function handleUpdate(query) {
      this.form = (0, _objectSpread2.default)({}, query);
      this.visible = true;
    }
  }]);
}(_vuePropertyDecorator.Vue);
ConfigModal = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], ConfigModal);
var _default = exports.default = ConfigModal;